/* Copied from growth-onboarding-shared-components/blob/master/growth-onboarding-shared-components/static/js/transitions/Confetti.js */
import { memo, useState, useLayoutEffect } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { CALYPSO, CANDY_APPLE, LORAX } from 'HubStyleTokens/colors';
import { GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CONFETTI_DURATION = 3000;
const CONFETTI_PIECES = 60;
const randomNum = (min, max) => {
  return min + Math.floor(Math.random() * (max - min + 1));
};
const rain = keyframes(["from{opacity:0;}25%{opacity:1;}to{bottom:0;}"]);
const confettiStyle = css(["animation:", " ease-out forwards;background:", ";border-radius:2px;bottom:100%;height:16px;opacity:0;position:absolute;width:5px;z-index:3;&:nth-child(odd){background:", ";}&:nth-child(even){z-index:1;}&:nth-child(3n){animation-duration:", "ms;height:25px;width:7px;}&:nth-child(4n){animation-duration:", "ms;border-radius:50%;height:10px;width:10px;}&:nth-child(4n-7){background:", ";}&:nth-child(8n){height:30px;width:4px;}"], rain, LORAX, CALYPSO, props => props.duration * 2, props => props.duration * 1.8, CANDY_APPLE);
const getConfettiPieceStyle = duration => {
  const randomDuration = randomNum(duration * 0.6, duration * 1.3);
  const randomDelay = randomNum(0, duration * 0.75);
  return {
    animationDelay: `${randomDelay}ms`,
    animationDuration: `${randomDuration}ms`,
    left: `${randomNum(0, 100)}%`,
    transform: `rotate(${randomNum(-80, 80)}deg)`
  };
};
const Confetti = ({
  className,
  duration: __duration
}) => {
  const [confettiPieces, setConfettiPieces] = useState([]);
  useLayoutEffect(() => {
    if (!confettiPieces) {
      return () => {};
    }
    if (confettiPieces.length >= CONFETTI_PIECES) {
      const timeoutId = setTimeout(() => setConfettiPieces(null), CONFETTI_DURATION * 2);
      return () => clearTimeout(timeoutId);
    }
    const newConfettiPieces = [...confettiPieces];
    for (let index = 0; index < 10; index += 1) {
      newConfettiPieces.push( /*#__PURE__*/_jsx("div", {
        className: className,
        style: getConfettiPieceStyle(CONFETTI_DURATION)
      }, confettiPieces.length + index));
    }
    const requestId = requestAnimationFrame(() => setConfettiPieces(newConfettiPieces));
    return () => cancelAnimationFrame(requestId);
  }, [className, confettiPieces, setConfettiPieces]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: confettiPieces
  });
};
const StyledConfetti = /*#__PURE__*/memo(styled(Confetti).withConfig({
  displayName: "Confetti__StyledConfetti",
  componentId: "sc-1kwbqy4-0"
})(["", ""], confettiStyle));
const ConfettiContainer = styled.div.withConfig({
  displayName: "Confetti__ConfettiContainer",
  componentId: "sc-1kwbqy4-1"
})(["@media only screen and (min-width:", "){height:", "%;left:", "%;overflow:hidden;pointer-events:none;position:absolute;top:-60px;width:", "%;", "}"], GRID_BREAKPOINT_SMALL, ({
  heightPercentage
}) => heightPercentage, ({
  widthPercentage
}) => (100 - widthPercentage) / 2, ({
  widthPercentage
}) => widthPercentage, ({
  fixedPosition
}) => {
  if (fixedPosition) {
    return `
         position: fixed;
         left: 0;
         top: 0;
         width: 100vw;
         height: 100vh;
         overflow: hidden;
        `;
  } else {
    return null;
  }
});
const WrappedConfetti = ({
  fixedPosition = false,
  heightPercentage = 200,
  widthPercentage = 200
}) => {
  return /*#__PURE__*/_jsx(ConfettiContainer, {
    fixedPosition: fixedPosition,
    heightPercentage: heightPercentage,
    widthPercentage: widthPercentage,
    children: /*#__PURE__*/_jsx(StyledConfetti, {})
  });
};
export default WrappedConfetti;